import {palette} from '../../../../lib/styleVariables';
import {convertHexToRGBA} from '../../../../lib/color-utils';

export const getHeaderColor = ({
  isHighlighted,
  isLinkActive,
  isScrolled
}: {
  isHighlighted?: boolean;
  isLinkActive?: boolean;
  isScrolled?: boolean;
}) => {
  if (isHighlighted)
    return !isScrolled
      ? {
        header: palette.white.base,
        link: isLinkActive ? convertHexToRGBA(palette.black.base, 0.1) : palette.white.base
      }
      : {
        header: palette.white.highlight,
        link: isLinkActive ? palette.white.base : palette.white.highlight
      };

  return {
    header: palette.white.highlight,
    link: isLinkActive ? palette.white.base : palette.white.highlight
  };
};
